import { SubscriptionPeriod } from '@anm/api/modules/subscription';
import useSwitchState from '@anm/hooks/useSwitchState';
import { useCallback, useEffect } from 'react';

import useChangePeriodHandler from '../../../..//hooks/subscription/useChangePeriodHandler';
import useSubscriptionChangeState from '../../../../components/pricing/PricingSubscriptionContent/hooks/useSubscriptionChangeState';

const useUpgradeUserSubscriptionModalControls = () => {
  const [
    isUpgradeModalOpen,
    openUpgradeModal,
    closeUpgradeModal
  ] = useSwitchState();

  const subscriptionChange = useSubscriptionChangeState();
  const handleChangePeriod = useChangePeriodHandler();

  const handleUpgradeModalOpen = useCallback((toPeriod: SubscriptionPeriod) => {
    handleChangePeriod(toPeriod);
    openUpgradeModal();
  }, []);

  useEffect(() => {
    !!subscriptionChange && closeUpgradeModal();
  }, [!!subscriptionChange]);

  return [
    isUpgradeModalOpen,
    handleUpgradeModalOpen,
    closeUpgradeModal
  ] as const;
};

export default useUpgradeUserSubscriptionModalControls;
